import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { GenericTimelyAccountId, OKGeneric } from '../../models';
import { apiAiAgentRoute } from './contract.ai.agent';
import { apiAiEngineRoute } from './contract.ai.engine.webhooks';
import { apiAiMemoriesRoute } from './contract.ai.memories';
import { apiAiNotesRoute } from './contract.ai.notes';
import { apiAiPredictionsRoute } from './contract.ai.predictions';
import { apiAiPreferencesRoute } from './contract.ai.preferences';

extendZodWithOpenApi(z);

const c = initContract();

export const apiAi = c.router({
  predictions: apiAiPredictionsRoute,
  notes: apiAiNotesRoute,
  preferences: apiAiPreferencesRoute,
  engine: apiAiEngineRoute,
  agent: apiAiAgentRoute,
  memories: apiAiMemoriesRoute,
  resetEverythingAi: {
    method: 'POST',
    path: `/1.0/ai/reset`,
    summary: 'Reset to default',
    description: 'Reset all AI-related data, including predictions, preferences, logs, etc',
    body: z.object({
      timely_account_id: GenericTimelyAccountId,
    }),
    responses: {
      200: OKGeneric,
    },
  },
});
